import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FormSectionComponent"] */ "/var/www/tmp.bua_frontend/src/components/ContentSections/FormSection.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/components/ContentSections/ImageGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tmp.bua_frontend/src/components/PageShuffle.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/Home.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/Kuenstler.module.scss");
